enum Texture {
  AUSTRIA = "url(#Austria)",
  ENGLAND = "url(#England)",
  FRANCE = "url(#France)",
  GERMANY = "url(#Germany)",
  ITALY = "url(#Italy)",
  LAND = "#F9F2E6",
  NEUTRAL_LAND = "url(#neutral-land-texture)",
  RUSSIA = "url(#Russia)",
  SEA = "#96B2B2",
  TURKEY = "url(#Turkey)",
}

export default Texture;
